<template>
  <div class="jtp">
    <div class="jtp-scopes">
      <button v-for="scope in scopes" :key="scope.value" type="button"
              class="jtp-scope" :class="{'is-active': value.scope === scope.value}"
              @click="setScope(scope.value)">
        <feather-icon :icon="scope.icon" size="15"/>
        <span>{{ msg(scope.label) }}</span>
      </button>
    </div>

    <div class="jtp-target">
      <v-select
          v-if="value.scope === 'BRANCH'"
          append-to-body
          :value="value.branchId"
          :options="branches"
          label="name"
          :reduce="branch => branch.id"
          :clearable="false"
          :placeholder="msg('Branch')"
          :dir="isRTL ? 'rtl' : 'ltr'"
          @input="patch({branchId: $event})"
      />
      <v-select
          v-else-if="value.scope === 'BUILDING'"
          append-to-body
          :value="value.buildingId"
          :options="buildings"
          label="label"
          :reduce="building => building.id"
          :clearable="false"
          :placeholder="msg('hm_hotel')"
          :dir="isRTL ? 'rtl' : 'ltr'"
          @input="patch({buildingId: $event})"
      />
      <v-select
          v-else-if="value.scope === 'ROOM_CATEGORY'"
          append-to-body
          :value="value.roomCategoryId"
          :options="categories"
          label="name"
          :reduce="category => category.id"
          :clearable="false"
          :placeholder="msg('roomcategory')"
          :dir="isRTL ? 'rtl' : 'ltr'"
          @input="patch({roomCategoryId: $event})"
      />
      <v-select
          v-else-if="value.scope === 'ROOM'"
          append-to-body
          :value="value.realEstateId"
          :options="rooms"
          label="label"
          :reduce="room => room.id"
          :clearable="false"
          :placeholder="msg('hm_room')"
          :dir="isRTL ? 'rtl' : 'ltr'"
          @input="patch({realEstateId: $event})"
      />
      <span v-else class="jtp-target__all">{{ msg('journeytargetall') }}</span>

      <b-form-input class="jtp-target__priority" type="number" :value="value.priority || 0"
                    v-b-tooltip.hover :title="msg('journeypriority')"
                    @input="patch({priority: Number($event) || 0})"/>
    </div>

    <small class="jtp__hint">{{ msg('journeytargethint') }}</small>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {JOURNEY_SCOPES} from '@/model/journey/journeyTypes'

/** Who gets this journey: org / branch / hotel / room category / single room. */
export default {
  name: 'journeyTargetPicker',
  props: {
    value: {type: Object, default: () => ({})},
  },
  data() {
    return {
      buildings: [],
      rooms: [],
    }
  },
  computed: {
    ...mapGetters('translator', ['msg']),
    ...mapGetters('appConfig', ['isRTL']),
    ...mapGetters('data', ['getAllBranches']),
    ...mapGetters('roomCategory', {categories: 'getRoomCategories'}),
    scopes() {
      return JOURNEY_SCOPES;
    },
    branches() {
      return Object.values(this.getAllBranches || {});
    },
  },
  created() {
    this.$store.dispatch('roomCategory/getAllForOrg').catch(() => {});
    this.loadBuildings();
  },
  methods: {
    setScope(scope) {
      this.patch({scope});
      if (scope === 'ROOM' && this.rooms.length === 0) this.loadRooms();
    },
    patch(patch) {
      this.$emit('input', {...this.value, ...patch});
    },
    loadBuildings() {
      const $this = this;
      this.$store.dispatch('building/getAllBuildings', {
        page: 1, amount: 999, filter: {}, sortcolumn: 'updatedDate', sortby: 'desc'
      }).then(data => {
        $this.buildings = (data['Buildings'] || []).map(building => ({
          id: building.id,
          label: building.company || building.address || building.id,
        }));
      }).catch(() => {
      });
    },
    loadRooms() {
      const $this = this;
      this.$store.dispatch('realEstate/getAllRealEstates', {
        page: 1, amount: 999, filter: {}, sortcolumn: 'updatedDate', sortby: 'desc'
      }).then(data => {
        $this.rooms = (data['RealEstates'] || []).map(room => ({
          id: room.id,
          label: (room.name || room.apt || room.id) + (room.address ? ' · ' + room.address : ''),
        }));
      }).catch(() => {
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.jtp-scopes {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.jtp-scope {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 11px;
  border-radius: 20px;
  border: 1px solid rgba(34, 41, 47, .12);
  background: #fff;
  font-size: 12.5px;
  font-weight: 600;
  color: #6e6b7b;
  cursor: pointer;

  &:hover {
    border-color: rgba(115, 103, 240, .5);
  }

  &.is-active {
    background: #7367f0;
    border-color: #7367f0;
    color: #fff;
  }
}

.jtp-target {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 8px;

  > .v-select {
    flex: 1;
    min-width: 180px;
  }

  &__all {
    flex: 1;
    color: #6e6b7b;
    font-size: 12.5px;
  }

  &__priority {
    width: 78px;
  }
}

.jtp__hint {
  display: block;
  margin-top: 4px;
  color: #6e6b7b;
}

.dark-layout {
  .jtp-scope {
    background: #283046;
    border-color: rgba(255, 255, 255, .1);
    color: #b4b7bd;
  }

  .jtp__hint, .jtp-target__all {
    color: #b4b7bd;
  }
}
</style>
